import templateUrl from './header-menus.html';
import size from "lodash/size";
import filter from "lodash/filter";
import reduce from "lodash/reduce";

export const headerMenusComponent = {
	bindings: {
		features: '<',
		showStickyHeader: '@'
	},

	templateUrl,

	controller: class HeaderMenusComponent {
		constructor($state, $stateParams, $transitions, HeaderMenusService, HomeService, $anchorScroll, $timeout, $parse, $window) {
			'ngInject';

			this.$state = $state;
			this.$stateParams = $stateParams;
			this.headerMenusService = HeaderMenusService;
			this.$anchorScroll = $anchorScroll;
			this.$timeout = $timeout;
			$transitions.onSuccess({}, this.onStateChangeSuccess.bind(this));
			this.$parse = $parse;
			this.$window = $window;
			this.homeService = HomeService;
		}

		onStateChangeSuccess() {
			this.$anchorScroll(() => $location.hash());
			this.isNavCollapsed = false;
			const state = this.$state.current;
			this.stateName = this.$state.current.name;
			this.allActiveMenusName = [];
			this.isTripplannerMenuActive = this._checkIsTripplannerMenuActive();
			this._getAllActiveMenusName(this.$stateParams.url);
			this._checkActiveMenuList();
			this._closeAllSubMenusInResponsive();
			this._activeDefaultHomeMenuIfUrlIsClean();
			this.hoverOut();
		}

		$onInit() {
			this.stateName = this.$state.current.name;
			this.isNavCollapsed = false;
			this.isSubNavCollapsed = true;
			this.isCollapsed = false;
			this._showStickyHeader = this.$parse(this.showStickyHeader || 'false')(false);
			this.socialLinks = [];
			this.showSocialLinks = false;
			this.isTripplannerMenuActive = this._checkIsTripplannerMenuActive();
			this._getSocialLinks();
		}

		stateRedirect(stateName) {
			this.isNavCollapsed = !this.isNavCollapsed;
			this.$state.go(stateName);
			this.features.map(value => value.isHovered = false);
		}

		hoverIn(feature) {
			this.features.map(value => value.isHovered = feature.menuId === value.menuId ? true : false);
		}

		hoverOut() {
			this.features.map(value => value.isHovered = false);
		}

		isMenuClicked(feature, isSubMenuOpen) {
			this.features.map(value => value.isClicked = feature.menuId === value.menuId ? isSubMenuOpen : false);
		}

		onSearch(searchKey) {
			this.isNavCollapsed = !this.isNavCollapsed;
			this.$state.go('SearchResults', {
				searchKey
			});
		}

		onChangeNavCollapsed() {
			this.isNavCollapsed = !this.isNavCollapsed;
			this._closeAllSubMenusInResponsive();
		}

		redirectToPage(slug) {
			this.$state.go("DynamicMenus", {
				url: slug
			});
		}

		$onChanges(changes) {
			if (changes && changes.showStickyHeader) {
				this._showStickyHeader = this.$parse(changes.showStickyHeader.currentValue || 'true')(true);
			}
		}

		// ========================================================= PRIVATE METHODS ===========================================================

		_activeDefaultHomeMenuIfUrlIsClean() {
			if(this.$stateParams.url === '') {
				 this._activeDefaultHomeMenu();
			}
		}

		_checkIsTripplannerMenuActive() {
			return this.$state.current.name === 'tripPlannerLandingPage';
		}

		_getAllActiveMenusName(url) {
			const slugs = url ? url.split('/') : [];
			this.allActiveMenusName = reduce(slugs, (slug, value, index) => {
				index === 0 ? slug.push(value) : slug.push(`${slug[index - 1]}/${value}`);
				return slug;
			}, []);
		}

		_getParentStateOfCurrentState(currentState) {
			return this.$state.get(currentState.parentState);
		}

		_checkActiveMenuList() {
			this._setActiveMenu(this.features);
		
			if (size(this.allActiveMenusName) > 0) {
				this.$stateParams.url === 'home' ? this._activeDefaultHomeMenu() : true;
			}
		}

		_activeDefaultHomeMenu() {
			this.features = this.features.map(feature => {
				feature.isMenuActive = (feature.name === 'Home') ? true : false;
				return feature;
			});
		}

		_setActiveMenu(features) {
			if (size(features) !== 0) {
				features.map(feature => {
					feature.isMenuActive = (this.allActiveMenusName.indexOf(feature.slug) !== -1) ? true : false;
					if (size(feature.subfeature) > 0) {
						this._setActiveMenu(feature.subfeature)
					}
				});
			}
		}

		_getSocialLinks() {
			this.homeService.getSocialLinks()
				.then(socialLinks => {
					this.socialLinks = socialLinks;
					this.showSocialLinks = this._checkIfAnySocialLinkExist(this.socialLinks);
				});
		}

		_checkIfAnySocialLinkExist(socialLinks) {
			const socialLinkWithUrlExist = filter(socialLinks, ({ url }) => url !== "");
			return size(socialLinkWithUrlExist) > 0 ? true : false;
		}

		_closeAllSubMenusInResponsive() {
			this.features.map(value => value.isClicked = false);
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/header-menus/header-menus.component.js